import { Fragment } from "react";
import { Href } from "../../../Constant";
import { EMAIL_SIDEBAR } from "../../../Data/Email";
import { Badge, NavItem } from "reactstrap";

const DynamicEmailSideBar = () => {
  return (
    <>
      {EMAIL_SIDEBAR &&
        EMAIL_SIDEBAR.map((item) => (
          <NavItem key={item.id}>
            {!item.line ? (
              <a href={Href}>
                <span className="title">
                  <i className={item.className}></i>
                  {item.title}
                </span>
                <Badge color="transparent" className="pull-right email-badge">
                  {item.badge && `(${item.badge})`}
                </Badge>
              </a>
            ) : (
              item.line
            )}
          </NavItem>
        ))}
    </>
  );
};

export default DynamicEmailSideBar;
